import { render, staticRenderFns } from "./ReportsDetail.vue?vue&type=template&id=74ce9c8f"
import script from "./ReportsDetail.vue?vue&type=script&lang=ts"
export * from "./ReportsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports